var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 65,
    rx: 10,
    fill: "#EEF8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 51.5714C41.5 43.8571 49 36.9494 49 28.4286C49 19.9076 42.2843 13 34 13C25.7157 13 19 19.9076 19 28.4286C19 36.9494 26.5 43.8571 34 51.5714Z",
    stroke: "#16A249",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34.4286C37.5505 34.4286 40.4286 31.5505 40.4286 28C40.4286 24.4496 37.5505 21.5714 34 21.5714C30.4495 21.5714 27.5714 24.4496 27.5714 28C27.5714 31.5505 30.4495 34.4286 34 34.4286Z",
    stroke: "#16A249",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.adb0cad8dc8e6d191d8873a1dd23bb47.svg";
export { ForwardRef as ReactComponent };